import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import RejectCancelModal from '../../../../views/order/common/modal/RejectCancelModal';
import withModal from '../../../../lib/hoc/withModal';
import { orderActions } from '../../../../store/modules/order';

class RejectCancelModalContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      /**
       *  취소 거부 사유
       */
      rejectReason: null,
    };
  }

  /**
   * 모달 닫기 || 데이터 초기화
   */
  closeModal = () => {
    const { toggleModal } = this.props;
    toggleModal({
      name: 'rejectCancelModal',
    });
  };

  /**
   * 취소 거부 하기
   */
  onSubmit = () => {
    const { form, data, rejectOrderCancel } = this.props;
    const { orderItemList } = data;
    const { rejectReason } = this.state;

    form.validateFields((err) => {
      if (err) return;

      rejectOrderCancel({
        orderItemIdList: orderItemList.map((item) => item.orderItemId),
        rejectReason,
      });

      this.closeModal();
    });
  };

  /**
   * 데이터 변경
   */
  setData = (data) => {
    this.setState({
      [data.name]: data.value,
    });
  };

  render() {
    const { isOpen, form, data } = this.props;

    return (
      <RejectCancelModal
        {...this.state}
        form={form}
        isOpen={isOpen}
        data={data}
        onSubmit={this.onSubmit}
        setData={this.setData}
        closeModal={this.closeModal}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.order.rejectCancelModal.isOpen,
    data: state.order.rejectCancelModal.data,
  };
};

const mapDispatchToProps = {
  toggleModal: orderActions.toggleModal,
  rejectOrderCancel: orderActions.rejectOrderCancel,
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal()(Form.create({})(RejectCancelModalContainer)));
